import { find, isEmpty } from 'lodash';

export enum ModuleId {
    // Legacy
    BusinessListings = 'business_listings',
    RequestReviews = 'request_reviews',
    ReviewResponse = 'review_response',
    Survey = 'survey',
    Social = 'social',
    AutoRespond = 'autorespond',

    // New
    AdConfiguring = 'ad-configuring',
    AdManaging = 'ad-managing',
    AnalyticAIReputationManager = 'analytic-ai-reputation-manager',
    AnalyticAILocationPresence = 'analytic-ai-location-presence',
    AnalyticAnalyze = 'analytic-analyze',
    AnalyticExperience = 'analytic-experience',
    AnalyticOperating = 'analytic-operating',
    AnalyticOperatingPlus = 'analytic-operating-plus',
    AnalyticReporting = 'analytic-reporting',
    AnalyticScoring = 'analytic-scoring',
    AnalyticSocialVoice = 'analytic-social-voice',
    AnalyticTraffic = 'analytic-traffic',
    AnalyticVoiceOfBrand = 'analytic-voice-of-brand',
    AnalyticVoiceOfCustomer = 'analytic-voice-of-customer',
    AnalyticVoiceOfEmployee = 'analytic-voice-of-employee',
    AnalyticCompetitiveInsightsCompassStandard = 'analytic-competitive-insights-compass-standard',
    AnalyticCompetitiveInsightsCompassPremium = 'analytic-competitive-insights-compass-premium',
    BrandSocialEngage = 'brand-social-engage',
    BrandSocialEngageDashboards = 'brand-social-engage-dashboards',
    BrandSocialPublish = 'brand-social-publish',
    BrandSocialPublishDashboards = 'brand-social-publish-dashboards',
    BrandSocialPublishSmartSocial = 'brand-social-publish-smart-social',
    CompetitiveInsightsBasic = 'competitive-insights-basic',
    CompetitiveInsightsLocal = 'competitive-insights-local',
    CompetitiveInsightsNational = 'competitive-insights-national',
    Datastore = 'datastore',
    DirectoryFinder = 'directory-finder',
    DirectoryListing = 'directory-listing',
    DirectoryListingDuplicate = 'directory-listing-duplicate',
    DirectoryListingPosts = 'directory-listing-posts',
    DirectoryLocator = 'directory-locator',
    DirectoryManaging = 'directory-managing',
    DirectoryPublishing = 'directory-publishing',
    DirectorySuggestions = 'directory-suggestions',
    DepartmentalListings = 'departmental-listings',
    GSRFulfilling = 'google-seller-ratings-fulfilling',
    Integrations = 'integrations',
    ListingAccuracy = 'listing-accuracy',
    KioskApproving = 'kiosk-approving',
    KioskModerating = 'kiosk-moderating',
    KioskMonitoring = 'kiosk-monitoring',
    KioskResponding = 'kiosk-responding',
    MessagingAutomatedResponding = 'messaging-automated-responding',
    MessagingCampaigns = 'messaging-campaigns',
    MessagingInbox = 'messaging-inbox',
    NewPlatformDashboard = 'analytic-reporting-dashboard',
    NewPlatformReport = 'analytic-reporting-report',
    PlatformAutomatedResponding = 'platform-automated-responding',
    PlatformCompetitiveIntelligence = 'platform-competitive-intelligence',
    PlatformConfiguring = 'platform-configuring',
    PlatformCustomers = 'platform-customers',
    PlatformDashboarding = 'platform-dashboarding',
    PlatformInbox = 'platform-inbox',
    PlatformManaging = 'platform-managing',
    PlatformProvisioning = 'platform-provisioning',
    PlatformReviewBooster = 'platform-review-booster',
    PlatformSearchAccelerator = 'platform-search-accelerator',
    PlatformSuggestedResponding = 'platform-suggested-responding',
    PlatformSyndication = 'platform-syndication',
    QAMonitoring = 'qa-monitoring',
    QAResponding = 'qa-responding',
    RepIQ = 'rep-iq',
    RequestManaging = 'request-managing',
    ReviewApproving = 'review-approving',
    ReviewInbox = 'review-inbox',
    ReviewModerating = 'review-moderating',
    ReviewTenantModerating = 'review-tenant-moderating',
    ReviewMonitoring = 'review-monitoring',
    ReviewResponding = 'review-responding',
    ScoreBasic = 'score-basic',
    ScorePerspective = 'score-perspective',
    ScoreTargets = 'score-targets',
    SearchRankingAdvance = 'map-ranking-advanced',
    SearchRankingBasic = 'map-ranking-basic',
    SearchRankingPremium = 'map-ranking-premium',
    SearchInsightsOrganic = 'search-insights-organic',
    SocialCampaigns = 'social-campaigns',
    SocialContent = 'social-content',
    SocialCurating = 'social-curating',
    SocialFulfilling = 'social-fulfilling',
    SocialInbox = 'social-inbox',
    SocialListening = 'social-listening',
    SocialListeningListen = 'social-listening-listen',
    SocialListeningListenDashboards = 'social-listening-listen-dashboards',
    SocialListeningListenHistoricalData = 'social-listening-historical-data',
    SocialListeningListenTopicMatchingSettings = 'social-listening-topic-matching-settings',
    SocialListeningListenSentimentRules = 'social-listening-sentiment-rules',
    SocialLocalCurating = 'social-local-curating',
    SocialMonitoring = 'social-monitoring',
    SocialPublishing = 'social-publishing',
    SocialRepository = 'social-repository',
    SocialResponding = 'social-responding',
    Social2 = 'social2',
    SurveyInbox = 'survey-inbox',
    SurveyLegacyApproving = 'survey-legacy-approving',
    SurveyLegacyModerating = 'survey-legacy-moderating',
    SurveyLegacyMonitoring = 'survey-legacy-monitoring',
    SurveyLegacyResponding = 'survey-legacy-responding',
    SurveyApproving = 'survey-approving',
    SurveyModerating = 'survey-moderating',
    SurveyMonitoring = 'survey-monitoring',
    SurveyResponding = 'survey-responding',
    Survey3Approving = 'survey3-approving',
    Survey3Conversational = 'survey3-conversational',
    Survey3Moderating = 'survey3-moderating',
    Survey3Monitoring = 'survey3-monitoring',
    Survey3Responding = 'survey3-responding',
    TaskFulfilling = 'task-fulfilling',
    TaskManaging = 'task-managing',
    TicketBasic = 'ticket-basic',
    TicketFulfilling = 'ticket-fulfilling',
    TicketManaging = 'ticket-managing',
    ActionPlansBasic = 'action-plan-basic',
    ActionPlansManaging = 'action-plan-managing',
    Survey3ResultsFeedUpdate = 'survey3-results-feed-update',
}

export enum ModuleLevel {
    SuperAgency = 'SuperAgency',
    Agency = 'Agency',
    Tenant = 'Tenant',
}

export interface ModuleSourceRule {
    moduleID: ModuleId;
    moduleRuleType: ModuleRuleType;
    sourceRuleType: SourceRuleType;
    sourceIDs: string[];
}

export enum ModuleRuleType {
    Inherit = 1,
    DoNotInherit = 2,
    Locked = 3,
}

export enum SourceRuleType {
    Included = 1,
    Excluded = 2,
}

export const getModuleSourceRule = (moduleSourceRules: ModuleSourceRule[], moduleId: ModuleId): ModuleSourceRule => {
    let rule = find(moduleSourceRules, {
        moduleID: moduleId,
    });

    if (!rule) {
        rule = {
            moduleID: moduleId,
            moduleRuleType: ModuleRuleType.Inherit,
            sourceRuleType: SourceRuleType.Excluded,
            sourceIDs: [],
        };
    }

    return rule;
};

export const isDefaultTenantModuleSourceRule = (moduleSourceRule: ModuleSourceRule): boolean => {
    return (
        moduleSourceRule.moduleRuleType === ModuleRuleType.Inherit &&
        moduleSourceRule.sourceRuleType === SourceRuleType.Excluded &&
        isEmpty(moduleSourceRule.sourceIDs)
    );
};
